import React, { useEffect, useState } from "react";

import { ReactComponent as LeftArrow } from "../../../../assets/appearencePage/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../assets/appearencePage/arrow-left-dark.svg";
import { Link } from "react-router-dom";

import { ReactComponent as Fill } from "../../../../assets/InvitationSystem/Fill.svg";
import { ReactComponent as FillDark } from "../../../../assets/InvitationSystem/Fill-dark.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/InvitationSystem/DeleteIcon.svg";
import { ReactComponent as WarningCircle } from "../../../../assets/InvitationSystem/WarningCircle.svg";
import { ReactComponent as CheckCircle } from "../../../../assets/InvitationSystem/CheckCircle.svg";

import useLocales from "../../../../hooks/useLocales";

import OgImage from "../../../../assets/landingPages/homePage/Hero.png";
import { Helmet } from "react-helmet";
import useSettings from "../../../../hooks/useSettings";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
import { useStateContext } from "../../../../contexts/ThemeContext";
import toast from "react-hot-toast";
import httpRequest from "../../../../axios/index";
import { useDispatch, useSelector } from "react-redux";
import {
  setEnteredSuccessEmails,
  setEnteredFailedEmails,
  removeFailedEmails,
  setTotalInvites,
} from "../../../../redux/slices/InvitationSystem/InvitationSlice";

const InvitionSystem = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const dispatch = useDispatch();

  const [emails, setEmails] = useState([]);
  const [focused, setFocused] = useState(false);
  const [isButtonDisabled, setButtonDisabled] = useState(false);

  const { setActiveInvitionSystemPageNav } = useStateContext();

  function inputStyle() {
    const inputElement = document.querySelector(".react-multi-email > input");
    const borderElement = document.querySelector(".react-multi-email");
    if (inputElement && borderElement) {
      inputElement.style.backgroundColor = darkMode ? "#3C3C3C" : "#fff";
      inputElement.style.color = darkMode ? "#fff" : "#000";
      borderElement.style.backgroundColor = darkMode ? "#3C3C3C" : "#fff";
    }
  }
  const {
    successEmails = [],
    failedEmails = [],
    totalInvites,
  } = useSelector((state) => state?.invitationListEmails);

  useEffect(() => {
    setActiveInvitionSystemPageNav(true);
    return () => {
      setActiveInvitionSystemPageNav(false);
    };
  }, []);

  const SubmitHandler = async (event) => {
    event.preventDefault();

    if (emails.length === 0) {
      toast.error("Please enter email address");
      return;
    }

    const { userid } = JSON.parse(localStorage.getItem("user"));
    setButtonDisabled(true);

    try {
      const payload = {
        userId: userid,
        emails: emails,
      };
      const url = "/api/user/invite";
      const response = await httpRequest.post(url, payload);
      const resultSuccessEmails = response?.data?.successEmails;
      const resultfailedEmails = response?.data?.failedEmails;
      const resultTotalInvites = response?.data?.user_data?.totalInvites;
      const result = response?.data?.message;
      const status = response?.data?.status;

      if (status === "Success") {
        toast.success(result);
        setEmails([]);
        dispatch(setEnteredSuccessEmails(resultSuccessEmails));
        dispatch(setEnteredFailedEmails(resultfailedEmails));
        dispatch(setTotalInvites(resultTotalInvites));
      }
    } catch (error) {
      if (error?.response?.data?.status === "failed") {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    } finally {
      setButtonDisabled(false);
    }
  };

  const ResendEmail = async (event) => {
    event.preventDefault();
    if (failedEmails?.length === 0) {
      toast.error("Please select an email");
      return;
    }

    const { userid } = JSON.parse(localStorage.getItem("user"));
    setButtonDisabled(true);
    try {
      const payload = {
        userId: userid,
        emails: failedEmails.map((email) => email?.email),
      };
      const url = "/api/user/resendFailedEmails";

      const response = await httpRequest.post(url, payload);
      const resultSuccessEmails = response?.data?.successEmails;
      const resultfailedEmails = response?.data?.failedEmails;
      const resultTotalInvites = response?.data?.user_data?.totalInvites;

      const result = response?.data?.message;
      const status = response?.data?.status;

      if (status === "success") {
        dispatch(setEnteredSuccessEmails(resultSuccessEmails));
        dispatch(setEnteredFailedEmails(resultfailedEmails));
        dispatch(setTotalInvites(resultTotalInvites));
        toast.success(result);
      }
    } catch (error) {
      if (error?.response?.data?.status === "failed") {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    } finally {
      setButtonDisabled(false);
    }
  };

  const handleRemoveFailedEmail = async (emailId) => {
    try {
      const url = `/api/user/deleteEmail/${emailId}`;

      const response = await httpRequest.delete(url);
      const status = response?.data?.status;
      if (status === "success") {
        dispatch(removeFailedEmails({ emailId }));
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>InvitionSystem | Bil.Bio</title>
        <meta property="og:title" content="InvitionSystem | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <div className="bg-light_bg_v4 dark:bg-dark-primary h-[100vh] overflow-y-auto">
        <div className="flex justify-center">
          <div className="2xl:max-w-screen-xl xl:max-w-screen-lg w-full">
            <div className="relative px-6 smm:px-8 xsmfold:pt-12 pt-28 py-12">
              <div className="flex md:hidden mt-10 mb-[38px] relative items-center pr-6">
                <div className="absolute inset-y-0 flex items-center justify-center">
                  <Link to={"/mDashboard"}>
                    {darkMode ? (
                      <LeftArrowDark
                        className={`h-[20px] w-[20px] ${
                          themeDirection === "rtl"
                            ? "transform -scale-x-100"
                            : ""
                        }`}
                      />
                    ) : (
                      <LeftArrow
                        className={`h-[20px] w-[20px] ${
                          themeDirection === "rtl"
                            ? "transform -scale-x-100"
                            : ""
                        }`}
                      />
                    )}
                  </Link>
                </div>
                <h6 className="w-full text-center text-heading_color text-body_copy1_b dark:text-color_v1_dark">
                  {translate("Invitation_System.invite_friend")}
                </h6>
              </div>
              <div className="hidden mb-[30px] md:flex items-center mt-10 gap-[10px] pl-1">
                <div
                  style={{
                    boxShadow: darkMode
                      ? ""
                      : "0px 0px 10px rgba(217, 217, 217, 0.1), -5px 6px 10px rgba(170, 170, 170, 0.3)",
                  }}
                  className="hidden md:flex justify-center items-center p-[9px] bg-white dark:bg-dark-secondary rounded-lg"
                >
                  {darkMode ? <FillDark /> : <Fill />}
                </div>
                <h6 className="text text-heading_color dark:text-color_v1_dark text-custom_h6">
                  {translate("Invitation_System.invite_friend")}
                </h6>
              </div>
              <div className="w-full bg-white dark:bg-dark-secondary rounded-[10px] md:rounded-[20px] lg:rounded-[30px] p-6 lg:p-[50px] md:mb-[90px]">
                <div className="min-h-[calc(100vh_-_335px)] flex flex-col justify-between overflow-y-scroll">
                  <div>
                    <h6 className="text text-heading_color dark:text-color_v1_dark text-custom_h6">
                      {translate("Invitation_System.invite_friend_cap")}
                    </h6>
                    <p className="text-small3 lg:text-small1 mt-2 lg:mt-2.5 text-font_light_color dark:text-font_dark_color">
                      {translate("Invitation_System.you_have")}
                      <span className="px-1" style={{ color: "#FF5349" }}>
                        {totalInvites}
                      </span>
                      {translate("Invitation_System.credits")}
                    </p>
                    <hr className="mt-4 lg:mt-5 dark:border-color_dark" />
                    <div>
                      <form>
                        <div>
                          <div className="mt-6 lg:mt-[30px]">
                            <div className="grid gap-5 lg:gap-[30px] mt-6 lg:mt-5 grid-cols-1 lg:grid-cols-3 ">
                              <div className="sm:col-span-2">
                                <label
                                  htmlFor="email"
                                  className="block ms-[15px] mb-2 text-heading_color dark:text-color_v1_dark text-small2 sm:text-body_copy2 "
                                >
                                  {/* Email */}
                                  {translate("email")}
                                </label>
                                <div className="relative">
                                  <ReactMultiEmail
                                    placeholder={translate(
                                      "front_end_pages.contact.enter_email"
                                    )}
                                    style={inputStyle()}
                                    emails={emails}
                                    onChange={(_emails) => {
                                      setEmails(_emails);
                                    }}
                                    autoFocus={true}
                                    onFocus={() => setFocused(true)}
                                    onBlur={() => setFocused(false)}
                                    getLabel={(email, index, removeEmail) => {
                                      return (
                                        <div
                                          key={index}
                                          className="w-auto	h-auto flex items-start gap-2 px-3 sm:pt-3 sm:pb-2.5 pt-1.5	pb-1 rounded-[20px] border-solid	border border-main_color bg-light_bg_v5 dark:bg-dark-secondary"
                                        >
                                          <p className="text-sm not-italic font-normal tracking-[-0.2px] text-font_light_color dark:text-color_v1_dark ">
                                            {email}
                                          </p>
                                          <div
                                            className="shrink-0 w-5 h-5 items-center	justify-center flex hover:cursor-pointer"
                                            onClick={() => removeEmail(index)}
                                          >
                                            <DeleteIcon />
                                          </div>
                                        </div>
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                              <div>
                                <button
                                  type="submit"
                                  onClick={SubmitHandler}
                                  disabled={isButtonDisabled}
                                  className="bg-main_color  lg:mt-9 text-white rounded-full h-12 pt-[7px] pb-[6px] smm:pt-[10px] smm:pb-[9px] sm:pt-[13px] sm:pb-[12px] text-small3_b smm:text-small2_b sm:text-small1_bold sm:w-48 w-full"
                                >
                                  {translate(
                                    "Invitation_System.invite_friend_cap"
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                      {successEmails?.length > 0 && (
                        <div className="mt-6 lg:mt-[30px]">
                          <div className="w-full flex items-center sm:gap-1.5 gap-2">
                            <div className="shrink-0 w-5 h-5 items-center	justify-center flex">
                              <CheckCircle />
                            </div>
                            <p className="text-sm sm:text-base tracking-[-0.2px] sm:tracking-[-0.3px] text-heading_color font-normal dark:text-color_v1_dark">
                              <span className="pr-1 font-normal sm:font-bold text-main_color tracking-[-0.2px] sm:tracking-[-0.3px] text-sm sm:text-base">
                                {successEmails?.length}
                              </span>
                              {translate("Invitation_System.invite_success")}
                            </p>
                          </div>
                          <div
                            className={`$ flex w-full flex-wrap items-start content-start sm:gap-1.5 gap-2 mt-1.5`}
                          >
                            {successEmails?.map((email, index) => (
                              <div
                                key={index}
                                className="w-auto h-auto flex items-start gap-2 px-3 sm:pt-3 sm:pb-2.5 pt-1.5	pb-1 rounded-[20px] border-solid	border border-main_color bg-light_bg_v5 dark:bg-dark-secondary"
                              >
                                <p className="text-sm not-italic font-normal tracking-[-0.2px] text-font_light_color dark:text-color_v1_dark">
                                  {email?.email}
                                </p>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {failedEmails?.length > 0 && (
                        <div className="mt-6 lg:mt-[30px]">
                          <div className="w-full flex items-center sm:gap-1.5 gap-2">
                            <div className="shrink-0 w-5 h-5 items-center	justify-center flex">
                              <WarningCircle />
                            </div>
                            <p className="text-sm sm:text-base tracking-[-0.2px] sm:tracking-[-0.3px] text-heading_color dark:text-color_v1_dark font-normal">
                              <span className="pr-1 font-normal sm:font-bold text-main_color tracking-[-0.2px] sm:tracking-[-0.3px] text-sm sm:text-base">
                                {failedEmails?.length}
                              </span>
                              {translate("Invitation_System.invite_failed")}
                            </p>
                          </div>
                          <div
                            className={`$ flex w-full flex-wrap items-start content-start sm:gap-1.5 gap-2 mt-1.5`}
                          >
                            {failedEmails?.map((email, index) => (
                              <div
                                key={index}
                                className="w-auto h-auto flex items-start gap-2 px-3 sm:pt-3 sm:pb-2.5 pt-1.5	pb-1 rounded-[20px] border-solid	border border-main_color bg-light_bg_v5 dark:bg-dark-secondary"
                              >
                                <p className="text-sm not-italic font-normal tracking-[-0.2px] text-font_light_color dark:text-color_v1_dark">
                                  {email?.email}
                                </p>
                                <div
                                  className="shrink-0 w-5 h-5 items-center	justify-center flex hover:cursor-pointer"
                                  onClick={() =>
                                    handleRemoveFailedEmail(email._id)
                                  }
                                >
                                  <DeleteIcon />
                                </div>
                              </div>
                            ))}

                            <button
                              type="submit"
                              onClick={ResendEmail}
                              disabled={isButtonDisabled}
                              className="text-main_color pt-[7px] pb-[6px] smm:pt-[10px] smm:pb-[9px] sm:pt-[13px] sm:pb-[12px] text-small3_b smm:text-small2_b sm:text-small1_bold ml-1.5"
                            >
                              {translate("Invitation_System.invite_resend")}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvitionSystem;
